import { Component, AfterViewInit, input, OnDestroy, inject } from '@angular/core';
import { ContextService } from '../context.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mutara-message-bar',
    template: `<markdown>{{message()}}</markdown>`,
    styles: ['p {text-wrap: balance; overflow-wrap: break-word; }'],
    standalone: false,
    
})
export class MessageBarComponent implements AfterViewInit, OnDestroy {
  message = input<string>('');
  subBar: Subscription | undefined;
  private context = inject<ContextService>(ContextService);
  
  ngAfterViewInit(): void {
    this.subBar = this.context.subscribeTo("messageBar",(messageText : string) => {
      this.message.apply(messageText);
    });
  }
  ngOnDestroy(): void {
    this.subBar?.unsubscribe();
  }
}